module.exports = __webpack_public_path__ + "assets/devices/PB-101-PG2-90264e71c6c475acc21c4832bb70b1d4.svg";